"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.writingStyles.disabled': '写作风格功能在您当前的计划中不可用。',
};
